const _temp0 = require("../intl/ar-AE.json");
const _temp1 = require("../intl/en-US.json");
module.exports = {
  "ar-AE": _temp0,
  "en-US": _temp1
}